import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
	async getCCMVaccinesByPatientId (patientId) {
		const response = await _axios.get(`/ccmvaccine/getbypatientid/${patientId}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting all CCM Vaccines by patient ID');
	},
	async getCCMVaccinesByCCMRecordId (ccmRecordId) {
		const response = await _axios.get(`/ccmvaccine/getbyccmrecordid/${ccmRecordId}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting all CCM Vaccines by patient ID');
	},
	async getCCMVaccine (id) {
		const response = await _axios.get(`/ccmvaccine/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error getting CCM Vaccine');
	},
	async addCCMVaccine (body) {
		const response = await _axios.post('/ccmvaccine', body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error adding CCM Vaccine');
	},
	async updateCCMVaccine (id, body) {
		const response = await _axios.put(`/ccmvaccine/${id}`, body);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error updating CCM Vaccine');
	},
	async deleteCCMVaccine (id) {
		const response = await _axios.delete(`/ccmvaccine/${id}`);
		if (response.data.resFlag) {
			return response.data;
		}
		throw new CCMError('Error deleting CCM Vaccine');
	},
};
